export default "/images/448340e008993152850edafa4a775689.avif";